module.exports = __webpack_public_path__ + "static/img/info.fbdb6bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floatingWindow/info.png
// module id = sYPC
// module chunks = 13